import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type RCaptionAlign = 'left' | 'center' | 'right';

interface RCaptionProps {
    children: React.ReactNode;
    align?: RCaptionAlign;
    className?: string;
}

export function RCaption({ children, align, className }: RCaptionProps) {
    return (
        <Caption $align={align} className={className}>
            {children}
        </Caption>
    );
}

const Caption = styled('span', {
    shouldForwardProp: (prop) => prop !== '$align',
})<{ $align?: RCaptionAlign }>(({ $align }) => ({
    fontSize: 13,
    fontWeight: 400,
    color: Colors.mediumGrey,
    textAlign: $align,
}));
